import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/PreAdvise/OOGDetails.css';
import Input from '../../Shared/Input';
import Button from '../../Shared/Button';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
class OOGDetails extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            OverlongBack: '',
            OverlongFront: '',
            OverwideLeft: '',
            OverwideRight: '',
            Overheight: '',
            errors: {}
        }
    }
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
    }
    OnValidated = () => {
        this.props.history.push("/home");
    }
    handleSubmit = () => {
        if (this.handleValidation()) {
            this.OnValidated();
        }
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        if (!this.state.OverlongBack) {
            formIsValid = false;
            errors["overlongBack"] = Message.validation.required;
            document.getElementsByName('OverlongBack')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('OverlongBack')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.OverlongFront) {
            formIsValid = false;
            errors["overlongFront"] = Message.validation.required;
            document.getElementsByName('OverlongFront')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('OverlongFront')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.OverwideLeft) {
            formIsValid = false;
            errors["overwideLeft"] = Message.validation.required;
            document.getElementsByName('OverwideLeft')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('OverwideLeft')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.OverwideRight) {
            formIsValid = false;
            errors["overwideRight"] = Message.validation.required;
            document.getElementsByName('OverwideRight')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('OverwideRight')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.Overheight) {
            formIsValid = false;
            errors["overheight"] = Message.validation.required;
            document.getElementsByName('Overheight')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('Overheight')[0].style.borderColor = ColorCode.colorCode.black;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    handleChangeOverlongBack = (e) => {
        this.setState({ OverlongBack: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                overlongBack: ''
            }
        });
        document.getElementsByName('OverlongBack')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeOverlongFront = (e) => {
        this.setState({ OverlongFront: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                overlongFront: ''
            }
        });
        document.getElementsByName('OverlongFront')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeOverwideLeft = (e) => {
        this.setState({ OverwideLeft: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                overwideLeft: ''
            }
        });
        document.getElementsByName('OverwideLeft')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeOverwideRight = (e) => {
        this.setState({ OverwideRight: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                overwideRight: ''
            }
        });
        document.getElementsByName('OverwideRight')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeOverheight = (e) => {
        this.setState({ Overheight: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                overheight: ''
            }
        });
        document.getElementsByName('Overheight')[0].style.borderColor = ColorCode.colorCode.black;
    }
    render() {
        return (
            <div class="caacsoutercolor">
                <MetaDecorator title={TitleDescription.OOGDetailsPageTitle} description={TitleDescription.OOGDetailsPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="caacsnofull">
                    <div id="oogcaacsnobox1">
                        <nav class="caacnononavbar">
                            <div className="arcaacnonavbarnameOOG">
                                <small id="nonavc">Add OOG</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="arcaanotificationmaincard">
                            <div class="caaoncsdivlow1">
                                <div class="adscsdivlow2">
                                    Enter OOG Details</div>
                            </div>
                            <div class="caadivup1">
                                <div class="caadivup4">
                                    <div class="caadivup55">
                                        <div class="caadivup3OOGDetails">
                                            <small id="caaname">Overlong Back (cm)</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="OverlongBack"
                                                    class="input" placeholder="Enter Overlong Back"
                                                    type="text" id="caad06" value={this.state.OverlongBack}
                                                    onChange={this.handleChangeOverlongBack}
                                                />
                                                <div className="oogdetailserror1">{this.state.errors["overlongBack"]}</div>
                                            </div>
                                        </div>
                                        <div class="caadivup3OOGDetails">
                                            <small id="caaname">Overlong Front (cm)</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="OverlongFront"
                                                    class="input" placeholder="Enter Overlong Front"
                                                    type="text" id="caad06" value={this.state.OverlongFront}
                                                    onChange={this.handleChangeOverlongFront}
                                                />
                                                <div className="oogdetailserror1">{this.state.errors["overlongFront"]}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3OOGDetails">
                                            <small id="caaname">Overwide Left (cm)</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="OverwideLeft"
                                                    class="input" placeholder="Enter Overwide Left"
                                                    type="text" id="caad06" value={this.state.OverwideLeft}
                                                    onChange={this.handleChangeOverwideLeft}
                                                />
                                                <div className="oogdetailserror1">{this.state.errors["overwideLeft"]}</div>
                                            </div>
                                        </div>
                                        <div class="caadivup3OOGDetails">
                                            <small id="caaname">Overwide Right (cm)</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="OverwideRight"
                                                    class="input" placeholder="Enter Overwide Right"
                                                    type="text" id="caad06" value={this.state.OverwideRight}
                                                    onChange={this.handleChangeOverwideRight}
                                                />
                                                <div className="oogdetailserror1">{this.state.errors["overwideRight"]}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3OOGDetails">
                                            <small id="caaname">Overheight (cm)</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="Overheight"
                                                    class="input" placeholder="Enter Overheight"
                                                    type="text" id="caad06" value={this.state.Overheight}
                                                    onChange={this.handleChangeOverheight}
                                                />
                                                <div className="oogdetailserror1">{this.state.errors["overheight"]}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="caabuttdivOOGDetails">
                                <Button class="caabuttdivOOGDetails1" onClick={this.handleSubmit}>
                                    <small class="caabuttdivOOGDetails2">Continue</small>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="caanotifooter01oog">
                    <Footer />
                </div>
                <div class="caanotifooter02oog">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
export default OOGDetails;